/**
 * フォーム確認画面の「戻る」ボタンを制御するクラス
 * submitBack ボタンがクリックされた際に、入力画面に戻る
 */
export class FormBackButton {
  private backButton: HTMLInputElement | null;

  constructor() {
    this.backButton = document.querySelector('input[name="submitBack"]') as HTMLInputElement;

    if (!this.backButton) {
      return;
    }

    this.init();
  }

  private init(): void {
    if (!this.backButton) return;

    this.backButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.goBack();
    });
  }

  private goBack(): void {
    // 現在のURLから ?type=confirm を削除して入力画面に戻る
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('type');

    // 入力画面にリダイレクト
    window.location.href = currentUrl.toString();
  }
}
